import * as types from './types';

export const handleNext = () => ({ type: types.HANDLE_NEXT });

export const handleBack = () => ({ type: types.HANDLE_BACK });

export const handleReset = () => ({ type: types.HANDLE_RESET });

export const setActiveStep = step => ({ type: types.SET_ACTIVE_STEP, step });
